import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import MuiPhoneNumber from 'material-ui-phone-number';
import { withStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/customPhoneInputStyle';
import FormControl from '@material-ui/core/FormControl';
import classNames from 'classnames';

class CustomPhoneInput extends Component {
	render() {
		const {
			classes, handleOnChange, disabled,
			handleOnBlur,
			formControlProps,
			id,
			value,
			error,
			success,
			helperText,
			isValid,
			countriesCodesList,
			defaultCountry,
		} = this.props;

		let formControlClasses;

		if (formControlProps !== undefined) {
			formControlClasses = classNames(
				formControlProps.className,
				classes.formControl
			);
		} else {
			formControlClasses = classes.formControl;
		}

		// eslint-disable-next-line no-unused-vars
		const helpTextClasses = classNames({
			[classes.helperText]: true,
			[' ' + classes.labelRootError]: error,
			[classes.labelRootSuccess]: success && !error
		});

		return (
			<div className={classes.wrapper}>
				<FormControl {...formControlProps} className={formControlClasses}>
					<MuiPhoneNumber
						id={id}
						value={value}
						disabled={disabled}
						label="Phone Number *"
						/*onlyCountries={countriesCodesList}*/
						/*disableAreaCodes={true}*/
						defaultCountry={defaultCountry}
						dropdownClass="modal-dropdown"
						onChange={handleOnChange}
						onBlur={handleOnBlur}
						error={error}
						isValid={isValid}
					/>
				</FormControl>
				{helperText && (
					<div className={classes.helperText}>{helperText}</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = ({ settings }) => {
	return {
		defaultCountry: /*settings.country?.code?.toLowerCase() ||*/ 'us',
		/*countriesCodesList: (settings?.allowedCountryForPhoneNumbers || [{ code: 'us' }]).map(({ code }) => code.toLowerCase()),*/
	};
};

const mapDispatchToProps = () => ({});

export default compose(
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps),
)(CustomPhoneInput);
